import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { LOGIN_ROUTES } from 'gcs-common/constants/routes';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Only render children when the user is logged in,
 * otherwise Navigate to LOGIN_ROUTES.LOGIN
 */
function LoggedInProtectedRoute({ children }: PropsWithChildren) {
  const { isSuccess } = useGetCurrentUser();

  if (!isSuccess) {
    return <Navigate to={LOGIN_ROUTES.LOGIN} />;
  }

  return children;
}

export default LoggedInProtectedRoute;
